import { useContacts } from '../hooks';
import { useAppContext } from '../../shared';
import { Form, FormItem, TopPanel } from '../../components';
import { SearchBar, Dropdown, Table } from '../../components';
import type { ContactItemType } from '../hooks';
import type { ColumnType } from '../../components';

type ContactsListTemplateProps = {
  buttons?: React.ReactNode;
  columns: ColumnType<ContactItemType>[];
  listResult: ReturnType<typeof useContacts>;

  children?: React.ReactNode;
};

const ContactsListTemplate: React.FC<ContactsListTemplateProps> = ({
  buttons,
  columns,
  children,
  listResult,
}) => {
  const { meta } = useAppContext();
  const { nodes, initializing, filters, setFilters, sort, setSort } =
    listResult;

  return (
    <div className="flex flex-col gap-y-md w-full">
      <TopPanel>
        <Form<NonNullable<typeof filters>>
          initialValue={filters}
          onChange={setFilters}
        >
          <FormItem<NonNullable<typeof filters>> name="search" label="">
            <SearchBar />
          </FormItem>
          <FormItem<NonNullable<typeof filters>>
            label=""
            name="latest_contact_state"
          >
            <Dropdown<LatestContactState>
              grow={false}
              placeholder="All Statuses"
              options={[
                { value: undefined, label: 'All Statuses' },
                { value: 'active', label: 'Active' },
                { value: 'READY_FOR_OUTREACH', label: 'Ready For Outreach' },
                { value: 'OUTREACH_FAILED', label: 'Outreach Failed' },
                { value: 'goal_reached', label: 'Goal Reached' },
                { value: 'null', label: 'No State' },
              ]}
            />
          </FormItem>
          <FormItem<NonNullable<typeof filters>>
            label=""
            name="requiresHumanInput"
          >
            <Dropdown
              placeholder="Human Input"
              grow={false}
              options={[
                { value: '', label: 'All Contacts' },
                { value: 'true', label: 'Requires Human Input' },
                { value: 'false', label: 'No Human Input Required' },
              ]}
            />
          </FormItem>
          <FormItem<NonNullable<typeof filters>> name="campaignId" label="">
            <Dropdown
              placeholder="Campaign"
              grow={false}
              options={[
                { value: '', label: 'All Campaigns' },
                ...meta.campaigns,
              ]}
            />
          </FormItem>
        </Form>
        {buttons}
      </TopPanel>
      {children}
      <div className="flex-1 overflow-y-auto">
        <Table
          data={nodes}
          loading={initializing}
          sort={sort}
          onSort={setSort}
          config={{ columns: columns }}
        />
      </div>
    </div>
  );
};

export default ContactsListTemplate;
